<template>
    <div class="banner">
        <div class="zone">
            <div class="rectangle">
                <div class="text">
                    <i class="yuzu-icon yuzu-ai" />Yuzu AI
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner {
    left: -40px;
    top: -40px;
    position: relative;
    align-self: start;

    .zone {
        width: 200px;
        height: 150px;
        margin-bottom: -150px;

        display: flex;
        align-items: center;

        overflow: hidden;
    }

    .rectangle {
        transform: rotate(325deg);
        height: 36px;

        background: #B889F7;

        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;

        position: relative;
        left: -40px;
        top: -35px;
    }

    .text {
        color: #1D1D1D;
        font-weight: 700;

        .yuzu-icon.yuzu-ai {
            display: inline-block;
            width: 15px;
            height: 16px;
            margin-right: 8px;

            background-image: none;
            background-color: #1d1d1d;
            mask-image: url(/src/assets/images/icon/yuzu-ai.svg);
        }
    }
}
</style>